import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/auth/Auth';
import Icon from 'components/_UI/Icon';
import paths from 'routes/paths';
import breakpoints from 'theme/breakpoints';
import { PrimaryButton, campaign } from './shared';

const ASSETS = '/assets/images/promo/3-anos';

export default function ClosingSection() {
    const navigate = useNavigate();
    const { isAuth } = useAuth();

    return (
        <Wrapper>
            <BgBlob src={`${ASSETS}/blob-glow.png`} alt="" aria-hidden="true" />
            <Mascot src={`${ASSETS}/gato-oculos.png`} alt="" aria-hidden="true" />

            <Content>
                <LogoBox>
                    <Icon name="whizr-inline-logo" />
                </LogoBox>

                <Title>Feliz aniversário pra gente.</Title>
                <Subtitle>Bons rolês pra você.</Subtitle>

                <PrimaryButton
                    onClick={() => navigate(isAuth ? paths.dashboard.events : paths.partner.createAccount)}
                >
                    Bora aproveitar a condição
                </PrimaryButton>
            </Content>
        </Wrapper>
    );
}

const Wrapper = styled.section`
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, ${campaign.purple} 0%, ${campaign.purpleDeep} 100%);
    padding: 72px 20px;
    text-align: center;

    @media screen and (min-width: ${breakpoints.smd}) {
        padding: 96px 32px;
    }
`;

const BgBlob = styled.img`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 520px;
    max-width: none;
    opacity: 0.5;
    pointer-events: none;
    user-select: none;
`;

const Mascot = styled.img`
    position: absolute;
    right: 6%;
    bottom: -10px;
    width: 90px;
    pointer-events: none;
    user-select: none;
    display: none;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: block;
        width: 120px;
    }
`;

const Content = styled.div`
    position: relative;
    z-index: 1;
    max-width: 560px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const LogoBox = styled.div`
    width: 110px;
    height: 34px;
    margin-bottom: 24px;
`;

const Title = styled.h2`
    font-size: 26px;
    font-weight: 800;
    color: #fff;
    margin: 0 0 8px;

    @media screen and (min-width: ${breakpoints.smd}) {
        font-size: 32px;
    }
`;

const Subtitle = styled.p`
    font-size: 17px;
    color: rgba(255,255,255,0.85);
    margin: 0 0 32px;
`;
